/* eslint-disable indent */
import { useEffect, useMemo, useRef, useState } from "react"
import Screen from "src/shared/components/layout/screen/Screen"
import Resumen from "./sections/Resumen/Resumen"
import { useLocation, useNavigate, useParams } from "react-router-dom"
import LabelTitle from "../../shared/components/data-display/LabelTitle/LabelTitle"
import {
    Reserva,
    TiposAlojamientos,
    TiposEntradas,
    TiposPagos,
    useCheckInMutation,
    useCreateRentaMutation,
    useGetHabitacionQuery,
    useTarifasLazyQuery,
    useGetIncidenciaByFiltersLazyQuery,
    useGetColaboradoresQuery,
    CreateRentaInput,
    useDescontarSaldoEasyrewardsMutation,
    useGetHabitacionTurnosAtencionQuery,
    useActualizarTurnoAtencionMutation,
    EstadosTurnosAtencion,
    EstatusTarifa,
    EstatusGrupoTarifa,
    TipoTarifa,
    ModalidadGrupoTarifa,
    TarifasQuery,
} from "src/gql/schema"
import { v4 as uuid } from "uuid"
import FormSection from "../../shared/components/forms/FormSection/FormSection"
import { Controller, FormProvider, useForm, useWatch } from "react-hook-form"
import InputTabs from "src/shared/components/forms/input-tabs/InputTabs"
import Dropdown from "src/shared/components/forms/selelct-dropdown/Dropdown"
import { useProfile } from "src/shared/hooks/useProfile"
import { getCurrencyFormat } from "src/utils/string"
import Counter from "src/shared/components/forms/counter/Counter"
import { InputText } from "src/shared/components/forms"
import Icon from "src/shared/icons"
import usePaymentOptions, { entryTypes, inputIconStyle, scheduleTypes } from "./VentaHabitacion.constants"
import { CardNumberField } from "./components/CardNumberField/CardNumberField"
import FormSectionRow from "../../shared/components/forms/FormSectionRow/FormSectionRow"
import { PAYMENT_METHODS, PAYMENT_TYPES } from "src/constants/payments"
import ModalMixto from "src/shared/sections/payment/mixto/ModalMixto"
import { useDispatch, useSelector } from "react-redux"
import { getPropinaList } from "src/shared/sections/payment/helpers/propinas"
import {
    selectTarifas,
    selectTarifasAdicionales,
    setTarifas,
    toggleModalPagoMixtoEdited,
    toggleModalPagoMixtoOpen,
} from "src/store/ventaHabitacion/ventaHabitacionSlice"
import { RootState } from "src/store/store"
import useResetPayments from "./hooks/useResetPayments"
import useResetForm from "./hooks/useResetForm"
import { useDate } from "src/shared/hooks/useDate"
import { getPaymentList } from "src/shared/sections/payment/Payment.helpers"
import useSnackbar from "src/shared/hooks/useSnackbar"
import { toggleRoomDetailsDrawer } from "src/store/navigation/navigationSlice"
import useReservaPayments from "./hooks/useReservaPayments"
import useSetFormStateFromReserva from "./hooks/useSetFormStateFromReserva"
import { addCurrentTime } from "src/shared/helpers/addCurrentTime"
import { minus, sum, times } from "src/shared/helpers/calculator"
import { addDays } from "src/shared/helpers/addDays"
import { substractDays } from "src/shared/helpers/substractDays"
import useShowPago from "./hooks/useShowPago"
import useShowPagoReserva from "./hooks/useShowPagoReserva"
import Switch from "src/shared/components/forms/switch/Switch"
import { formatCurrency } from "src/shared/hooks/formatCurrency"
import useValidSameDayRent from "./hooks/useValidSameDayRent"
import { ventaHabitacionDefaultValues } from "./helpers/genDefaultValues"
import LoaderComponent from "src/shared/components/layout/loader/Loader"
import useEscapeKey from "src/shared/hooks/useEscapeKey"
import ModalMatricula from "./sections/ModalMatricula/ModalMatricula"
import useModalMatricula from "./hooks/useModalMatricula"
import InputTextSuggestions from "src/shared/components/forms/input-text-suggestions/InputTextSuggestions"
import { isValidPropina } from "./helpers/isVisibleCardNumber"
import InputMoney from "src/shared/components/forms/InputMoney/InputMoney"
import DollarCircle from "src/shared/icons/DollarCircle"
import accountBoxFill from "src/shared/icons/accountBoxFill"
import { DetallePago } from "src/shared/sections/payment/types/pagos"
import { AbonarEasyRewardsField } from "../easyrewards/components/AbonarEasyRewardsField/AbonarEasyRewardsField"
import useIsLoadingData from "./hooks/useIsLoadingData"
import { LovePoint } from "src/pages/easyrewards/components/InputAbonarEasyRewards/InputAbonarEasyRewards.types"
import ModalLovePointsError from "../easyrewards/components/ModalLovePointsError/ModalLovePointsError"
import { useModulos } from "src/shared/hooks/useModulos"
import ModalPagoMixtoLovePoints from "../easyrewards/components/ModalPagoMixtoLovePoints/ModalPagoMixtoLovePoints"
import { CardNumber } from "../room-service/detalle-compra/sections/Fields"
import { PaymentMethodField, PaymentTypeField } from "./sections/FieldsValetParking"
import useAuthOnTarifaNocheSelect from "./hooks/useAuthOnTarifaNocheSelect"
import useAuthOnCortesiaSelect from "../../shared/hooks/useAuthOnCortesiaSelect"
import useAuthOnCortesiaFromMixtoSelect from "../../shared/hooks/useAuthOnCortesiaFromMixtoSelect"
import { RoleNames } from "src/shared/hooks/useAuth"
//import { useCurrentDate } from "src/shared/providers/CurrentdateProvider"
import { useFormatDate } from "src/shared/hooks/useFormatDate"
import MultipleSelectDropdown from "src/shared/components/forms/MultipleSelectDropdown/MultipleSelectDropdown"
import { useMotorTarifas, useOpcionesTarifas } from "src/shared/hooks/useMotorTarifas"
import ModalDescuentos, { useStateDescuentos } from "src/shared/modals/ModalDescuentos/ModalDescuentos"
import {InputDate} from "./components/InputDate/InputDate"
import { useConfig } from "./hooks/useConfig"
import { useCosts } from "./hooks/useCosts"
import { DefaultValuesType } from "./VentaHabitacion.types"
import "./VentaHabitacion.css"

const VentaHabitacion = () => {
    const { habitacion_id = "" } = useParams()
    const navigate = useNavigate()
    const [getTarifas] = useTarifasLazyQuery()
    const { hotel_id, turno_hotel_id, usuario_id, zona_horaria } = useProfile()
    const { localDateToUTCString, diffDays, areSameDay, setHHMMSS } = useDate(zona_horaria)
    const dispatch = useDispatch()
    const [crearRenta] = useCreateRentaMutation()
    const [actualizarListaEspera] = useActualizarTurnoAtencionMutation()

    const { showSnackbar } = useSnackbar()
    const location = useLocation()
    const reserva = location?.state?.reservaSeleccionada as Reserva

    // hook para crear una renta cuando viene de una reserva
    const [checkIn] = useCheckInMutation()
    const [newScheduleTypes, setNewScheduleTypes] = useState<any>(scheduleTypes)

    //const { currentDate } = useGetCurrentDate()
    const { nowHotel, formatCustomDate, getStartOfHotelDayISO } = useFormatDate()

    const { isLoading: isDataLoading, setIsLoading } = useIsLoadingData()

    const { isModalPagoMixtoEdited, isModalPagoMixtoOpen, tarifas, tarifasSeleccionadas, tarifasAdicionalesSeleccionadas } = useSelector(
        (root: RootState) => root.ventaHabitacion
    )
    const experienciasSeleccionadas = reserva?.experiencias_reserva || []
    const experiencias = experienciasSeleccionadas.map((exp) => ({
        experiencia: { nombre: exp.experiencia?.nombre || "" },
        total: exp.total || 0,
    }))

    const methods = useForm({ defaultValues: ventaHabitacionDefaultValues })

    const tipoHospedaje = methods.watch("type")
    const tarifas_seleccionadas = methods.watch("tarifas")
    const tarifas_adicionales = methods.watch("tarifas_adicionales")

    const extraHours = methods.watch("extraHours")
    const extraHospedajes = methods.watch("extraHospedajes")

    const extraUsers = methods.watch("extraUsers")
    const dateRange = methods.watch("date")
    const costoGeneral = methods.watch("costs.general")
    const costoTotal = methods.watch("costs.total")
    const isEarlyCheckIn = methods.watch("earlyCheckIn")
    const tipoEntrada = methods.watch("entryType")
    const pagos = useWatch({ control: methods.control, name: "extra" })

    const matricula = methods.watch("matricula")
    const modeloAuto = methods.watch("modelo")
    const marcaAuto = methods.watch("marca")
    const colorAuto = methods.watch("color")

    const nombreHuesped = methods.watch("name")
    const method = methods.watch("method")
    const personas = methods.watch("users")
    const porcentajePropina = methods.watch("porcentajePropina")
    const montoPropina = methods.watch("montoPropina")
    const costos = methods.watch("costs")
    const propinas = methods.watch("propinas")

    const [propinasFormatted, setpropinasFormatted] = useState<DetallePago[]>([])
    const { descuento, metodos_sin_descuento, setDescuento } = useStateDescuentos()
    const ticketIdRef = useRef<string>("")
    const [lovePointsAmount, setLovePointsAmount] = useState<LovePoint | null>(null)
    const [lovePointsAmountGlobal, setLovePointsAmountGlobal] = useState<LovePoint | null>(null)
    const [easyRewardsIdReserva, setEasyRewardsIdReserva] = useState<string | null>(null)
    const { rolName } = useProfile()

    const [getIncidenciasHuesped, { loading, data: incidenciasHuesped }] = useGetIncidenciaByFiltersLazyQuery()
    const [getIncidenciasMatricula, { data: incidenciasMatricula }] = useGetIncidenciaByFiltersLazyQuery()
    const [modalMessage, setModalMessage] = useState<string>("")
    const [isModalPagoMixtoLovePointsOpen, setModalPagoMixtoLovePointsOpen] = useState(false)
    const [isModalLovePointsErrorOpen, setModalLovePointsErrorOpen] = useState(false)
    const { easyRewards: withEasyrewards } = useModulos()

    const [descontarSaldoEasyrewards] = useDescontarSaldoEasyrewardsMutation()

    const { data: colaboradores } = useGetColaboradoresQuery({
        variables: {
            hotel_id,
        },
    })
    const config = useConfig()

    const getCurrentDate = (): Date => nowHotel

    const getTodayDate = () => {
        const date = getCurrentDate()

        return {
            fecha_inicio: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
            fecha_final: new Date(date.getFullYear(), date.getMonth(), date.getDate() + 1),
        }
    }

    const { data: habitacion } = useGetHabitacionQuery({
        variables: {
            habitacion_id,
            usuario_id
        },
        onError: () => {
            navigate("/u")
        },
    })

    useEffect(() => {
        return () => {
            dispatch(setTarifas([]))
        }
    }, [])

    useEffect(() => {
        if (!habitacion) return

        setIsLoading({ key: "habitacion", value: false })
        getTarifas({
            variables: {
                hotel_id,
                tipo_habitacion_id: habitacion.habitacion.tipo_habitacion_id,
                estatus: EstatusTarifa.Activa,
                tipo_tarifa: !reserva ? TipoTarifa.Renta : null
            },
        }).then((t) => {
            setIsLoading({ key: "tarifa", value: false })

            const fetch_tarifas: TarifasQuery["tarifas"] = t.data?.tarifas || []

            const tarifas_lista = fetch_tarifas.filter((t)=>{
                const grupo = t?.grupo_tarifa
                return !tarifas ? !t?.eliminado && !grupo?.eliminado && grupo?.estatus === EstatusGrupoTarifa.Activa : true
            })
            const tarifas_reserva_ids = [...new Set(reserva?.reservas_tarifas?.map((i)=>i.tarifa_id) || [])]

            if(tarifas_reserva_ids.length > 0) {
                const tarifas_reserva_filter = tarifas_lista.filter((i)=> tarifas_reserva_ids?.includes(i.tarifa_id))
                const find_tarifa_reserva_local = tarifas_reserva_filter.find((i)=>i?.grupo_tarifa?.modalidad === ModalidadGrupoTarifa.Base)
                const find_tarifa_reserva_fetch = tarifas_lista.filter((i)=>i?.tipo_tarifa === "reserva" && i?.tipo_alojamiento === "hotel" && i?.grupo_tarifa?.modalidad === ModalidadGrupoTarifa.Base) || []
                const tarifas_reserva = find_tarifa_reserva_local ? tarifas_reserva_filter : [...find_tarifa_reserva_fetch, ...tarifas_reserva_filter]
                dispatch(setTarifas(tarifas_reserva))
            } else {
                const tarifas_renta_filter = tarifas_lista.filter(({ tipo_tarifa = "" }) => tipo_tarifa.includes("renta")) || []
                const tarifas_renta: TarifasQuery["tarifas"] = []
                const formatos_horas = habitacion.habitacion.tipo_habitacion?.formatos_duracion_horas || []

                tarifas_renta_filter.forEach((t)=>{
                    if (t.tipo_alojamiento === TiposAlojamientos.Motel) {
                        const duracion = Number(t?.grupo_tarifa?.duracion || 0)
                        if (formatos_horas.some((f)=>!f?.eliminado && f?.valor === duracion)) {
                            tarifas_renta.push(t)
                        }
                    } else {
                        tarifas_renta.push(t)
                    }
                })

                dispatch(setTarifas(tarifas_renta))
            }
        })
        .catch((e)=>{
            console.log(e)
            dispatch(setTarifas([]))
        })

        const easyRewardsReserva =
            habitacion.habitacion?.ultima_reserva?.reserva?.pagos?.[0]?.detalles_pago?.[0]?.easyrewards_id || null
        setEasyRewardsIdReserva(easyRewardsReserva)
    }, [habitacion?.habitacion?.habitacion_id])

    const tipo_habitacion_id = habitacion?.habitacion?.tipo_habitacion_id || ""

    const turnoAtencionId = location?.state?.folio_turno_id
    const { data: dataListaEspera } = useGetHabitacionTurnosAtencionQuery({
        variables: {
            hotel_id,
            turno_atencion_id: [turnoAtencionId],
        },
        skip: !turnoAtencionId,
    })
    const folioListaEspera = dataListaEspera?.turnos_atencion?.[0]?.folio_turno

    // hook para transformar los pagos de una reserva en pagos del formulario y hacer operaciones
    const { totalReservaPagos } = useReservaPayments({
        reserva: reserva as Reserva,
    })

    // Establece los valores del formulario de acuerdo a los valores de la reserva
    const [setFormState] = useSetFormStateFromReserva({
        setValue: methods.setValue,
    })

    const { Modal } = useAuthOnTarifaNocheSelect({
        tipoHabitacionIdSelected: tipo_habitacion_id,
        tipoHospedajeSelected: tipoHospedaje,
        setValue: (v) => methods.setValue("type", v),
        disabled: !!reserva,
    })

    const { Modal: ModalAuthCortesia } = useAuthOnCortesiaSelect({
        setValue: (v) => methods.setValue("method", v),
        tipoPago: method as TiposPagos,
    })

    const { Modal: ModalAuthCortesiaFromMixto } = useAuthOnCortesiaFromMixtoSelect({
        setValue: (v) => methods.setValue("extra", v),
        tipoPagoList: pagos,
    })

    const [roomDays, setRoomDays] = useState(1)
    const prevTotalRef = useRef<number>(0)

    // Reinicia los contadores cuando se modifica la selección del tipo de hospedaje o tarifa
    const { updateResetForm } = useResetForm({ setValue: methods.setValue })

    const {
        isModalMatriculaOpen,
        isModalMatriculaOpenFromState,
        setIsModalMatriculaOpen,
        setIsModalMatriculaOpenFromState,
    } = useModalMatricula({ setValue: methods.setValue, tipoEntrada })

    // mostrar campo de pago si los pagos de reserva son menores a lo que se ha agregado a la renta
    const { isShowingPago, setIsShowingPago } = useShowPago({ isFromReserva: !!reserva })

    // mostrar campo de pago si los pagos de reserva son iguales a lo que se ha agregado a la renta
    const { isShowingPagoReserva, setIsShowingPagoReserva } = useShowPagoReserva({
        isFromReserva: !!reserva,
    })

    const todayDate = useMemo(() => getTodayDate(), [nowHotel])

    const fechas_motor = useMemo(() => {
        const startDate = dateRange?.[0] || todayDate.fecha_inicio
        const fecha_inicio = getStartOfHotelDayISO(startDate)

        const endDateRaw = dateRange?.[1]
            ? !areSameDay(dateRange?.[0], dateRange?.[1])
                ? substractDays({ date: dateRange?.[1], days: 1 })
                : dateRange?.[1]
            : startDate

        return {
            fecha_inicio,
            fecha_fin: getStartOfHotelDayISO(endDateRaw)
        }
    }, [dateRange, todayDate])

    const { opciones_tarifas_adicionales, opciones_tarifas_hotel, opciones_tarifas_motel } = useOpcionesTarifas({ fechas: [new Date(fechas_motor.fecha_inicio), new Date(fechas_motor.fecha_fin)], tarifas, showAll: !!reserva })

    const { resumen_tarifas, total_tarifas, desglose_tarifas, costo_early_checkin, tarifa_ultimo_dia, tarifa_primer_dia } = useMotorTarifas({ 
        tarifas: tarifasSeleccionadas,
        tarifas_adicionales: tarifasAdicionalesSeleccionadas,
        tipo: tipoHospedaje,
        horas_extra: extraHours,
        personas_extra: extraUsers,
        hospedajes_extra: extraHospedajes,
        fecha_inicio: fechas_motor.fecha_inicio,
        fecha_final: fechas_motor.fecha_fin
     })

      const { isBetween12AMAndCheckInHour, isBetween12AMAndCheckOutHour } = useValidSameDayRent(
        config.hora_checkin,
        !!reserva,
        config.hora_checkout
    )

     const { getUpdateCosts } = useCosts()

    // Reinicia los pagos (excepto los previos que vienen de una reserva) al realizar cambios que afecten a estos para evitar incongruencias
    const { resetPayment, resetAfterDescuento } = useResetPayments({ setValue: methods.setValue, costoGeneral: costoGeneral })

    const [isVentaLoading, setIsVentaLoading] = useState(false)

    useEffect(() => {
        if (methods?.formState?.errors?.date) {
            showSnackbar({
                status: "error",
                title: "Error al vender habitación",
                text: "¡Ups! La fecha seleccionada no es válida. Por favor, elige una fecha correcta e inténtalo de nuevo.",
            })
        }
    }, [methods.formState])

    useEffect(()=>{
        if (!reserva || tarifas.length === 0) {
            return
        }

        setFormState({ reserva, tarifas })
    }, [reserva, tarifas])

    useEffect(() => {
        if (reserva) {
            return
        }

        const config = habitacion?.habitacion.tipo_habitacion?.config_tipo_estancia
        const validPaths = [config?.estancia_por_horas ? TiposAlojamientos.Motel : "", config?.estancia_por_noches ? TiposAlojamientos.Hotel : ""].filter((v)=>v)
        const tipoAlojamiento = validPaths?.[0] || ""

        const localType = methods.getValues("type")

        if(!localType) {
            const updatedScheduleTypes = scheduleTypes.map((item) => ({
                ...item,
                disabled: !validPaths.includes(item.value),
                }))
            setNewScheduleTypes(updatedScheduleTypes)
            methods.setValue("type", tipoAlojamiento)
        }

        if (tipoAlojamiento && tarifas.length > 0) {
            setTimeout(()=> setTarifaPorDefault(tipoAlojamiento), 500)
        }
    }, [habitacion?.habitacion, reserva, tarifas])

    useEffect(()=>{
        if (method && descuento.descuento_id && metodos_sin_descuento.includes(method as TiposPagos)) {
            setDescuento({ descuento_id: "", visible: false, total: 0, nombre: "" })
        }
    }, [method, descuento.descuento_id])

    useEffect(() => {
        if (
            easyRewardsIdReserva !== null &&
            lovePointsAmount?.id !== easyRewardsIdReserva &&
            reserva
        ) {
            setLovePointsAmount({
                id: easyRewardsIdReserva,
                saldo: lovePointsAmount?.saldo || 0,
            })
        }
    }, [easyRewardsIdReserva, lovePointsAmount])

    useEffect(() => {
        setLovePointsAmount(null)
        setLovePointsAmountGlobal(null)
    }, [methods.getValues("method")])

    // Establecer la lista de propinas formateadas
    useEffect(() => {
        const propinasList = getPropinaList(
            pagos.map((e) => ({
                subtotal: e.amount,
                tipo_pago: e.type,
                ultimos_digitos: e.number || "",
                easyrewards_id: "",
            })) || [],
            propinas?.length ? propinas : [{ id: "0", value: Number(montoPropina) || 0 }]
        )
        setpropinasFormatted(propinasList)
    }, [JSON.stringify(propinas), pagos, costos.general, montoPropina])

    // Establecer el monto de propina de un pago único al cambiar el % de la propina con los botones
    useEffect(() => {
        if (porcentajePropina === "Otro") {
            methods.setValue("montoPropina", 0)
            return
        }
        methods.setValue("montoPropina", times(costos.general, Number(porcentajePropina)))
    }, [porcentajePropina])

    // Resetear todo lo relacionado a propinas y consumo interno al cambiar de metodo de pago
    useEffect(() => {
        methods.setValue("propinas", ventaHabitacionDefaultValues.propinas)
        methods.setValue("montoPropina", ventaHabitacionDefaultValues.montoPropina)
        methods.setValue("porcentajePropina", ventaHabitacionDefaultValues.porcentajePropina)
        methods.setValue("colaboradorRecibioPropina", ventaHabitacionDefaultValues.colaboradorRecibioPropina)
        methods.setValue("colaboradorConsumoInterno", ventaHabitacionDefaultValues.colaboradorConsumoInterno)
    }, [method])

    useEffect(() => {
        if (colaboradores) {
            return setIsLoading({ key: "colaboradores", value: false })
        }
    }, [colaboradores])

    useEffect(() => {
        dispatch(selectTarifas(tarifas_seleccionadas?.map((tarifa_id)=>tarifas.find((t) => t.tarifa_id === tarifa_id))))
        dispatch(selectTarifasAdicionales(tarifas_adicionales?.map((tarifa_id)=>tarifas.find((t) => t.tarifa_id === tarifa_id))))
    }, [tarifas_seleccionadas, tarifas])

    useEffect(() => {
        methods.setValue("earlyCheckIn", false)
        if (!dateRange.length) {
            return setRoomDays(1)
        }
        if (tipoHospedaje === "motel") {
            return setRoomDays(1)
        }
        const diasEstancia = diffDays(addCurrentTime(dateRange?.[0]) || nowHotel, addCurrentTime(dateRange?.[1]))

        if (isNaN(diasEstancia)) {
            return setRoomDays(1)
        }
        setRoomDays(diasEstancia < 1 ? 1 : diasEstancia)
    }, [dateRange])

    useEffect(() => {
        const total_experiencias = experienciasSeleccionadas.reduce((acc, exp) => acc + exp.total, 0)
        const costo_early_check_in = isEarlyCheckIn ?  costo_early_checkin  : 0
        
        const subtotal = totalReservaPagos > 0 ? minus(Number(reserva?.total || 0), totalReservaPagos) : sum([ total_tarifas, total_experiencias, costo_early_check_in ])
        const new_total = minus(subtotal, descuento.total)

        if (prevTotalRef.current !== new_total) {
            prevTotalRef.current = new_total
            methods.setValue("costs", getUpdateCosts({ total: new_total, total_tarifas, total_experiencias, total_reservas: totalReservaPagos, desglose_tarifas, costo_early_check_in,  subtotal }))
        }
    }, [total_tarifas, totalReservaPagos, experienciasSeleccionadas, isEarlyCheckIn, descuento.total])

    useEffect(() => {
        updateResetForm({
            reserva: reserva,
            nowHotel,
            numero_personas: Number(habitacion?.habitacion?.tipo_habitacion?.personas_incluidas || 0),
            isBetween12AMAndCheckOutHour,
        })
    }, [habitacion, isBetween12AMAndCheckInHour, reserva, nowHotel.getTime()])

    useEffect(() => {
        setIsShowingPago({ totalRenta: costos.general })
        setIsShowingPagoReserva({ totalRenta: costos.general })
    }, [costos.general])

    useEffect(() => {
        resetPayment(isShowingPago)
        if (lovePointsAmount?.id) {
            setLovePointsAmount(null)
            setLovePointsAmountGlobal(null)
        }
    }, [tipoHospedaje, dateRange, extraHours, extraUsers, isEarlyCheckIn, costoTotal, isShowingPago])

    useEffect(() => {
        const turno = dataListaEspera?.turnos_atencion?.[0]
        if (!turno) return

        if (turnoAtencionId && turno.estado === EstadosTurnosAtencion.EnEspera) {
            updateListaEspera(turnoAtencionId, EstadosTurnosAtencion.EnCurso)
        }
    }, [dataListaEspera, turnoAtencionId])

    const setTarifaPorDefault = (tipoHospedaje: string) => {
        const find_tarifa_base_id = tarifas.find((t)=>t.tipo_alojamiento === tipoHospedaje && t.grupo_tarifa?.modalidad === "base")?.tarifa_id || ""
        const tarifas_ids: string[] = find_tarifa_base_id ? [find_tarifa_base_id] :  []
        const localTarifas = methods.getValues("tarifas")
        
        if (JSON.stringify(localTarifas) !== JSON.stringify(tarifas_ids)) {
            methods.setValue("tarifas", tarifas_ids)
        }
    }

    const handleLovePointsChange = (value) => {
        setLovePointsAmountGlobal(value)
        if (value && value !== null) {
            setLovePointsAmount({
                id: value.id,
                saldo: value.saldo,
            })
        }
    }


    const onSubmit = async (data: DefaultValuesType) => {
        let formattedDate = ""
        if (isVentaLoading) {
            return
        }
        setIsVentaLoading(true)
        const easyRewardsId = lovePointsAmount?.id

        // Verificar los pagos con LovePoints
        const lovePointsPayments = data.extra.filter((pago) => pago.type === "love_points")
        const totalLovePointsUsed = lovePointsPayments.reduce((acc, pago) => acc + pago.amount, 0)

        // Saldo y ID disponibles
        const saldoDisponible = lovePointsAmountGlobal?.saldo || lovePointsAmount?.saldo || 0
        const idMembresia = lovePointsAmountGlobal?.id || lovePointsAmount?.id || "N/A"

        // Validar si el saldo es suficiente
        if (lovePointsPayments.length > 0 && easyRewardsId) {
            if (totalLovePointsUsed > saldoDisponible) {
                setModalMessage(
                    `Esta membresía <strong>ID ${idMembresia} </strong> no tiene saldo suficiente para completar la transacción. <br>
                     Te recomendamos intentar nuevamente con otra forma de pago.<br>
                     Actualmente, el huésped cuenta con <strong> ${saldoDisponible} puntos </strong> en su cuenta.`
                )
                setModalLovePointsErrorOpen(true)
                setIsVentaLoading(false)
                return
            }

            const disccountVerificationSuccess = await disccountVerificationLovePoints(easyRewardsId)
            if (!disccountVerificationSuccess.success) {
                if (disccountVerificationSuccess.message === "Love Points desactivados") {
                    showSnackbar({
                        title: "Love Points desactivados",
                        text: "¡Ups! El huésped debe activar sus Love Points desde el portal.",
                        status: "error",
                    })
                    setIsVentaLoading(false)
                    return
                }
                if (disccountVerificationSuccess.message !== "El numero de transaccion no es valido") {
                    showSnackbar({
                        title: "Error desconocido",
                        text: "¡Ups! Se ha producido un error inesperado. Por favor, inténtalo nuevamente.",
                        status: "error",
                    })
                    setIsVentaLoading(false)
                    return
                }
            }
        }

        if (data.type === "hotel") {
            // renta para el mismo día pero con tarifa que termina antes de la fecha y hora actuales
            const endDate = setHHMMSS({
                startDate: data.date[0],
                newHour: tarifa_ultimo_dia?.hora_checkout || "",
                isNewHourInUTC: true,
            })

           formattedDate = localDateToUTCString(
                addDays({
                    date: endDate,
                    days: roomDays,
                })
            )
        }
        if (reserva) {
            const estadoPagoReserva = reserva?.estado_pago

            const pagoObject =
                estadoPagoReserva !== "pagado"
                    ? {
                          pago: {
                              detallesPago: [
                                  ...getPaymentList(
                                      data.extra.map((pago) => ({
                                          ...pago,
                                          easyrewards_id: easyRewardsId,
                                      }))
                                  ),
                              ],
                              total: sum([...getPaymentList(data.extra).map((v) => v.subtotal)]),
                              hotel_id,
                              usuario_id,
                          },
                      }
                    : {}

            checkIn({
                variables: {
                    datos_checkIn: {
                        horas_extra_renta: data.extraHours,
                        early_checkin: data.earlyCheckIn,
                        ...(propinasFormatted.length
                            ? {
                                  propina: {
                                      colaborador_id: data.colaboradorRecibioPropina?.id || "",
                                      detalles_pago: propinasFormatted,
                                      turno_id: turno_hotel_id,
                                  },
                              }
                            : {}),
                        personas_extra_renta: data.extraUsers - reserva?.personas_extras,
                        ...(data.matricula
                            ? {
                                  vehiculo: {
                                      modelo: data.modelo || "",
                                      matricula: data.matricula || "",
                                      color: data.color || "",
                                      marca: data.marca || "",
                                  },
                              }
                            : {}),
                        fecha_salida: reserva.fecha_salida,
                        tipo_entrada: data.entryType as TiposEntradas,
                        usuario_id,
                        reserva_id: reserva.reserva_id,
                        ...(data?.extra?.length && estadoPagoReserva !== "pagado" ? pagoObject : {}),
                        easyrewards_id: easyRewardsId,
                    },
                },
            })
                .then((res) => {
                    showSnackbar({
                        text: `La habitación **${habitacion?.habitacion.tipo_habitacion?.nombre} ${habitacion?.habitacion.numero_habitacion}** ha sido vendida`,
                        status: "success",
                        title: "Renta de habitación exitosa",
                    })
                    dispatch(toggleRoomDetailsDrawer(false))
                    if (res?.data?.checkIn[0]) {
                        window.location.href = `print://${res?.data?.checkIn[0]}_0/`
                    }
                    navigate("/u")
                })
                .catch((err) => {
                    showSnackbar({
                        title: "Error al rentar habitación",
                        status: "error",
                        text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente",
                    })
                })
                .finally(() => {
                    setIsVentaLoading(false)
                    dispatch(toggleRoomDetailsDrawer(false))
                })
            return
        }

        const fecha_checkin = localDateToUTCString(
            setHHMMSS({
                startDate: getCurrentDate(),
                newHour: tarifa_primer_dia?.hora_checkin || "",
                isNewHourInUTC: true,
            })
        )

        // Se agregó el campo “fecha_checkin” cuando el tipo es hotel, en horario que se registre la venta
        const datos_renta: CreateRentaInput = {
            comentarios: [],
            fecha_checkin,
            ...(data.type === "hotel"
                ? { fecha_fin: formattedDate, fecha_checkin: getCurrentDate().toISOString() }
                : {}),
            habitacion_id,
            early_checkin: data.earlyCheckIn,
            ...(propinasFormatted.length
                ? {
                      propina: {
                          usuario_id,
                          hotel_id,
                          colaborador_id: data?.colaboradorRecibioPropina?.id || "",
                          detalles_pago: propinasFormatted,
                          turno_id: turno_hotel_id,
                      },
                  }
                : {}),
            numero_personas: data.users,
            personas_extra: data.extraUsers,
            tarifa_ids: data.type === "hotel" ? [...data.tarifas, ...data.tarifas_adicionales] : data?.tarifas,
            tipo_entrada: data.entryType,
            usuario_id,
            nombre_huesped: data.name.length ? data.name : null,
            total: data.costs.general,
            tipo_alojamiento: data.type as TiposAlojamientos,
            horas_extra: data.extraHours,
            hotel_id,
            ...(data.type === "hotel" ? {
                dias_estancias: data.date[1]
                    ? roomDays
                    : extraHospedajes,
                hospedajes_extra: 0,
            } : {
                hospedajes_extra: extraHospedajes
            }),
            ...(data.matricula
                ? {
                      vehiculo: {
                          modelo: data?.modelo || "",
                          matricula: data?.matricula || "",
                          color: data?.color || "",
                          marca: data?.marca || "",
                      },
                  }
                : {}),
            easyrewards_id: easyRewardsId,
            ...(data.method === PAYMENT_METHODS.consumoInterno.value && data.colaboradorConsumoInterno?.id
        ? { consumo_interno_colaborador_id: data.colaboradorConsumoInterno.id }
        : {}),
        ...(descuento.descuento_id ?  { descuento_id: descuento.descuento_id } : {})
        }
        if (data.paymentType === "pendiente") {
            delete datos_renta.pago
            datos_renta.easyrewards_id = easyRewardsId || data.extra[0]?.easyrewards_id || ""
        } else if (data.paymentType === "parcial") {
            const pagosParciales = data.extra.filter((pago) => pago.type === "love_points")
            const totalAbonoParcial = pagosParciales.reduce((acc, pago) => acc + pago.amount, 0)

            datos_renta.pago = {
                detallesPago: getPaymentList(
                    pagosParciales.map((pago) => ({
                        ...pago,
                        easyrewards_id: easyRewardsId,
                    }))
                ),
                total: totalAbonoParcial,
                hotel_id,
                usuario_id,
            }
        } else if (data.extra.length > 0) {
            datos_renta.pago = {
                detallesPago: getPaymentList(
                    data.extra.map((pago) => ({
                        ...pago,
                        tipo_pago: pago.type,
                        easyrewards_id: easyRewardsId,
                    }))
                ),
                total: sum(data.extra.map((pago) => pago.amount)),
                hotel_id,
                usuario_id,
            }
        }
        crearRenta({
            variables: {
                datos_renta,
            },
        })
            .then((res) => {
                showSnackbar({
                    text: `La habitación **${habitacion?.habitacion.tipo_habitacion?.nombre} ${habitacion?.habitacion.numero_habitacion}** ha sido vendida`,
                    status: "success",
                    title: "Renta de habitación exitosa",
                })
                const generatedTicketId = res?.data?.crear_renta?.ticket?.ticket_id[0] || ""
                const generatedFolioRenta = res?.data?.crear_renta?.renta?.renta_id || ""

                ticketIdRef.current = generatedTicketId

                const hasLovePointsPm = data.extra.filter(
                    (pago: { type: TiposPagos }) => pago.type === TiposPagos.LovePoints
                )

                if (hasLovePointsPm.length > 0) {
                    hasLovePointsPm.forEach(async (pago: { number?: string; amount: number }) => {
                        const folioToSend = generatedTicketId || generatedFolioRenta
                        const result = await disccountLovePoints(folioToSend, pago.number || "", pago.amount)

                        if (result === null) {
                            showSnackbar({
                                title: "Error al descontar puntos",
                                text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente.",
                                status: "error",
                            })
                            setIsVentaLoading(false)
                        }
                    })
                }
                if (turnoAtencionId) {
                    updateListaEspera(turnoAtencionId, EstadosTurnosAtencion.Finalizado, generatedFolioRenta)
                }

                window.location.href = generatedTicketId
                    ? `print://${generatedTicketId}_0/`
                    : `print://${generatedFolioRenta}_4/`
                navigate("/u")
                dispatch(toggleRoomDetailsDrawer(false))
            })
            .catch((err) => {
                console.error(err)
                if (
                    err.message ===
                    "No se puede realizar el cobro por concepto de early-checkin despues de la hora de checkin de la tarifa"
                ) {
                    showSnackbar({
                        title: "Error al rentar habitación",
                        status: "error",
                        text: err.message,
                    })
                }
                showSnackbar({
                    title: "Error al rentar habitación",
                    status: "error",
                    text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente",
                })
            })
            .finally(() => {
                setIsVentaLoading(false)
            })
    }

    useEscapeKey({
        onEscape: () => {
            if (isModalMatriculaOpen) {
                setIsModalMatriculaOpen(false)
                methods.setValue("entryType", TiposEntradas.APie)
            }
            if (isModalPagoMixtoOpen) {
                methods.setValue("extra", [])
                methods.setValue("method", "")
                dispatch(toggleModalPagoMixtoOpen(false))
                dispatch(toggleModalPagoMixtoEdited(false))
                return
            }
            navigate("/u")
        },
    })

    /**funcion aplicar mutacion descuento de lovePoints */
    const disccountLovePoints = async (ticket_id: string, easyrewards_id: string, puntos_descontar: number) => {
        try {
            const response = await descontarSaldoEasyrewards({
                variables: {
                    easyrewards_id: easyrewards_id,
                    puntos_descontar: puntos_descontar,
                    folio_ticket: ticket_id,
                    hotel_id,
                },
            })

            if (
                response.data?.descuenta_puntos?.saldo !== undefined &&
                response.data?.descuenta_puntos?.saldo !== null
            ) {
                response.data.descuenta_puntos.saldo
            } else {
                return showSnackbar({
                    title: "Error al descontar puntos",
                    text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente.",
                    status: "error",
                })
            }
        } catch {
            return showSnackbar({
                title: "Error al descontar puntos",
                text: "¡Ups! Se ha producido un error. Por favor, inténtalo nuevamente.",
                status: "error",
            })
        }
    }

    /**funcion para verificar si estan activos los puntos de lovePoints */
    const disccountVerificationLovePoints = async (easyrewards_id: string) => {
        try {
            const response = await descontarSaldoEasyrewards({
                variables: {
                    easyrewards_id: easyrewards_id,
                    puntos_descontar: 1,
                    folio_ticket: "",
                    hotel_id,
                },
            })
            const saldo = response.data?.descuenta_puntos?.saldo
            return saldo !== undefined && saldo !== null
                ? { success: true, message: "" }
                : { success: false, message: "Error desconocido" }
        } catch (error: any) {
            const errorMessage =
                error?.graphQLErrors?.[0]?.message || typeof error.message === "string"
                    ? error.message.toLowerCase()
                    : ""

            const errorMessages = errorMessage.includes("el numero de transaccion no es valido")
                ? "El numero de transaccion no es valido"
                : errorMessage.includes("love points desactivados")
                ? "Love Points desactivados"
                : "Error desconocido"

            return { success: false, message: errorMessages }
        }
    }

    /** función para actualizar el estado del turno en lista de espera */
    const updateListaEspera = async (turno_atencion_id: string, estado: EstadosTurnosAtencion, renta_id?: string) => {
        try {
            await actualizarListaEspera({
                variables: {
                    input: {
                        turno_atencion_id,
                        estado,
                        ...(renta_id && { renta_id }),
                    },
                },
            })
        } catch (error) {
            showSnackbar({
                title: "Error al atender turno",
                text: `¡Ups! Ocurrió un error al atender el turno  **${folioListaEspera}**`,
                status: "error",
            })
        }
    }

    const getDinamycValue = (tarifas_seleccionadas: string[], tarifas_actuales: string[], selecion_tarifa_id: string, opciones:any[]) => {
        const opcion_fechas = opciones.find((i)=>i.value === selecion_tarifa_id)?.fechas || ""

        const fechas_iguales: string[] = []
        opciones.filter((i)=>{
            if(i?.modalidad !== "base" && opcion_fechas === i?.fechas) {
                fechas_iguales.push(i.value)
            }
        })

         if(tarifas_seleccionadas.includes(selecion_tarifa_id)) {
            return tarifas_seleccionadas.filter((key)=> key !== selecion_tarifa_id)
        } else if(fechas_iguales) {
            const filter = fechas_iguales.filter((i)=>i !== selecion_tarifa_id) 
            return tarifas_actuales.filter((key)=> !filter.includes(key))
        } else {
            return tarifas_actuales
        }
    }

    const handleSelectTarifas = (values: string[], adicionales?: boolean) => {
        const payload = values.map((tarifa_id)=>{
            return tarifas.find((t)=>t.tarifa_id === tarifa_id)
        })
        dispatch(adicionales ? selectTarifasAdicionales(payload) : selectTarifas(payload))
    }

    const handleResetTarifasAdicionales = ({ resetTarifas = false }) => {
        const adicionales = methods.getValues("tarifas_adicionales") || [] 
        const tarifas_base = methods.getValues("tarifas") || []
        
        if (adicionales.length > 0)  {
            dispatch(selectTarifasAdicionales([]))
            methods.setValue("tarifas_adicionales", [])
        }

        if(resetTarifas && tarifas_base.length > 1) {
            const tarifa_base_id = opciones_tarifas_hotel?.[0]?.value
            const payload = tarifas.filter((t)=>t.tarifa_id === tarifa_base_id)
            dispatch(selectTarifas(payload))
            methods.setValue("tarifas", tarifa_base_id ? [tarifa_base_id] : [])
        }
    }

    const handleChangeTipoHospedaje = (tipo: string) => {
         // Reiniciar el día cuando cambia el tipo de hospedaje, esto para que cuando se hayan seleccionado
        if (!reserva) {
            const today = setHHMMSS({ startDate: nowHotel, newHour: "00:00:00", isNewHourInUTC: false })
            
            methods.setValue("date", tipo === TiposAlojamientos.Motel ? [today] : [today, addDays({ date: today, days: 1 })])
        }
        // Seleccionar la primer tarifa por defecto
        setTarifaPorDefault(tipo)

        handleResetTarifasAdicionales({ resetTarifas: false })
        
        if (descuento.descuento_id) setDescuento({ descuento_id: "", total: 0, nombre: "", visible: false })
    }

    return (
        <Screen
            title={`Venta habitación ${habitacion?.habitacion?.tipo_habitacion?.nombre || ""} ${
                habitacion?.habitacion.numero_habitacion || ""
            }${folioListaEspera ? ` - Turno ${folioListaEspera}` : ""} `}
            back
            onBack={async () => {
                if (turnoAtencionId) {
                    await updateListaEspera(turnoAtencionId, EstadosTurnosAtencion.EnEspera)
                    navigate(-1)
                } else {
                    navigate("/u")
                }

                dispatch(toggleRoomDetailsDrawer(false))
            }}
            className="venta-habitacion__container"
        >
            <FormProvider {...methods}>
                <form onSubmit={methods.handleSubmit(onSubmit)}>
                    <div className="venta-habitacion__sections">
                        <div className="venta-habitacion__sections__form">
                            <div className="venta-habitacion__header-labels">
                                <LabelTitle
                                    icon="openDoor"
                                    text={`Habitación ${habitacion?.habitacion.tipo_habitacion?.nombre || ""}`}
                                />
                                {habitacion?.habitacion.tipo_habitacion?.camas?.map((c) => (
                                    <LabelTitle
                                        key={uuid()}
                                        icon="BedFilled"
                                        text={`${c.numero || ""} cama(s) ${c.tipo}(es)`}
                                    />
                                ))}
                                <LabelTitle
                                    icon="UserParentFill"
                                    text={`${
                                        habitacion?.habitacion.tipo_habitacion?.personas_incluidas || "-"
                                    } personas`}
                                />
                                <LabelTitle
                                    icon="userAdd"
                                    text={`Máximo ${tarifa_ultimo_dia?.tipo_habitacion?.personas_extra_max || "0"} personas extra`}
                                />
                            </div>
                            <FormSection title="">
                                <FormSectionRow className={"venta-habitacion__form-section__grid-tipo"}>
                                    <Controller
                                        control={methods.control}
                                        name={"type"}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <InputTabs
                                                disabled={isVentaLoading || isDataLoading}
                                                label="Tipo"
                                                items={newScheduleTypes}
                                                value={value}
                                                onChange={(e) => {
                                                    if(reserva) return
                                                    if(!e) return
                                                    onChange(e)
                                                    handleChangeTipoHospedaje(e)
                                                }}
                                            />
                                        )}
                                    />
                                    {tipoHospedaje  !== "hotel" ? (
                                        <Controller
                                            control={methods.control}
                                            name={"tarifas"}
                                            rules={{ required: true }}
                                            render={({ field: { value, onChange }, fieldState: { error } }) => (
                                                <div className="venta-habitacion-input" style={{ width: "100%" }}>
                                                    <Dropdown
                                                        disabled={!!reserva}
                                                        icon={"dollarCircle"}
                                                        iconInOptions={false}
                                                        errorHintText={error ? "Selecciona una opción" : ""}
                                                        label={"Tarifa base o temporadas"}
                                                        placeholder={"Selecciona una tarifa"}
                                                        options={opciones_tarifas_motel}
                                                        value={value?.[0] || ""}
                                                        onClick={({ value }) => {
                                                            const payload = value ? [value] : []
                                                            onChange(payload)
                                                            handleSelectTarifas(payload)
                                                        }}
                                                    />
                                                </div>
                                            )}
                                        />
                                    ) : (
                                        <>
                                            <Controller
                                                name="date"
                                                control={methods.control}
                                                rules={{
                                                    required: true,
                                                    validate: (v) => v.length > 1,
                                                }}
                                                // onChange del Controller le da el nuevo valor al input dentro del estado del formulario y le establece también el valor a este DatePicker
                                                render={({
                                                    field: { onChange: onFieldChange, value: fieldValue },
                                                    formState: { errors },
                                                }) => (
                                                    <InputDate
                                                        disabled={!!reserva}
                                                        selectableOnDblClick={isBetween12AMAndCheckOutHour}
                                                        errorHintText={errors.date ? "Selecciona un rango de fechas" : ""}
                                                        onChange={(v) => {
                                                            handleResetTarifasAdicionales({ resetTarifas: true })
                                                            onFieldChange(v)
                                                        }}
                                                        value={fieldValue}
                                                    />
                                                )}
                                            />
                                            <div/>
                                            <Controller
                                                control={methods.control}
                                                name={"tarifas"}
                                                rules={{ required: true }}
                                                render={({ field: { value, onChange }, fieldState: {error} }) => (
                                                    <MultipleSelectDropdown<any>
                                                        options={opciones_tarifas_hotel.map((item, index)=>{
                                                            return {
                                                                ...item,
                                                                available: value?.[0] ? index !== 0 : true
                                                            }
                                                        })}
                                                        errorHintText={error ? "Selecciona una opción" : ""}
                                                        icon={"dollarCircle"}
                                                        onChange={(currentValue, lastItem)=>{
                                                            const values = getDinamycValue(value, currentValue, lastItem, opciones_tarifas_hotel)
                                                            onChange(values)
                                                            handleSelectTarifas(values)
                                                        }}
                                                        value={value}
                                                        staticShowLabel={ `Tarifa base${value.length > 1 ? ` + ${value.length - 1} tarifa(s)` : ""}`}
                                                        placeholder="Selecciona una opción"
                                                        label="Tarifa base o temporadas"
                                                        disabled={!!reserva}
                                                        abbreviateLabel={false}
                                                        dinamycOptions={true}
                                                    /> 
                                                )}
                                            />
                                            <Controller
                                                control={methods.control}
                                                name={"tarifas_adicionales"}
                                                rules={{ required: false }}
                                                render={({ field: { value, onChange }, fieldState: { error } }) => (
                                                    <MultipleSelectDropdown<any>
                                                        options={opciones_tarifas_adicionales}
                                                        errorHintText={error ? "Selecciona una opción" : ""}
                                                        icon={"dollarCircle"}
                                                        onChange={(currentValue, lastItem)=>{
                                                            const values = getDinamycValue(value, currentValue, lastItem, opciones_tarifas_adicionales)
                                                            onChange(values)
                                                            handleSelectTarifas(values, true)
                                                        }}
                                                        value={value}
                                                        placeholder="Selecciona una opción"
                                                        label="Tarifas adicionales (opcional)"
                                                        disabled={!!reserva}
                                                        dinamycOptions={true}
                                                    />
                                                )}
                                            />
                                        </>
                                    )}
                                    <Controller
                                        control={methods.control}
                                        name={"users"}
                                        rules={{ required: true, min: 1 }}
                                        render={({ field: { value, onChange } }) => (
                                            <div className="venta-h-screen__count" style={{ width: "100%", gap: 0 }}>
                                                <p className="venta-h-screen__count__label">Personas</p>
                                                <Counter
                                                    title="personas"
                                                    className="venta-h-screen__counter"
                                                    max={
                                                        habitacion?.habitacion.tipo_habitacion?.personas_incluidas || 0
                                                    }
                                                    min={reserva?.numero_personas || 1}
                                                    value={value}
                                                    onClick={(lvalue) => {
                                                        const valueNumPersonasExtra =
                                                            methods.getValues("extraUsers") || 0
                                                        if (valueNumPersonasExtra > 0 && lvalue < value) {
                                                            methods.setValue("extraUsers", valueNumPersonasExtra - 1)
                                                            onChange(value)
                                                        } else {
                                                            onChange(lvalue)
                                                        }
                                                    }}
                                                    disable={
                                                        !habitacion?.habitacion.tipo_habitacion?.personas_incluidas ||
                                                        Number(
                                                            habitacion?.habitacion.tipo_habitacion?.personas_incluidas
                                                        ) === 0
                                                    }
                                                    errorHintText={
                                                        methods.formState?.errors?.users
                                                            ? "*El número de personas es requerido"
                                                            : ""
                                                    }
                                                />
                                            </div>
                                        )}
                                    />
                                </FormSectionRow>
                            </FormSection>
                            <FormSection title="Extras" style={{ marginBottom: 30 }}>
                                <FormSectionRow className="venta-habitacion__form-section__extras-row">
                                    <Controller
                                        control={methods.control}
                                        name={"extraUsers"}
                                        rules={{ required: false, min: 0 }}
                                        render={({ field: { value, onChange } }) => (
                                            <div style={{ position: "relative" }}>
                                                <div className="venta-h-screen__count">
                                                <p className="venta-h-screen__count__label">
                                                    Personas extra
                                                    {false ? (
                                                        <span>{`(${getCurrencyFormat(
                                                            tarifa_ultimo_dia?.costo_persona_extra
                                                        )} c/u)`}</span>
                                                    ) : null}
                                                </p>
                                                <Counter
                                                    title="Personas extra"
                                                    className="venta-h-screen__counter"
                                                    min={reserva?.personas_extras || 0}
                                                    value={value}
                                                    onClick={(lvalue) => {
                                                        const valueNumPersonas = methods.getValues("users") || 0
                                                        const numMaxPersonas =
                                                            habitacion?.habitacion.tipo_habitacion
                                                                ?.personas_incluidas || 0
                                                        if (valueNumPersonas >= numMaxPersonas) {
                                                            onChange(lvalue)
                                                        } else if (lvalue > (value || 0)) {
                                                            methods.setValue("users", valueNumPersonas + lvalue)
                                                        }
                                                    }}
                                                    disable={
                                                        !config.personas_extra ||
                                                        !tarifa_ultimo_dia?.tipo_habitacion?.personas_extra_max ||
                                                        Number(tarifa_ultimo_dia?.tipo_habitacion?.personas_extra_max) === 0 ||
                                                        !!reserva
                                                    }
                                                />
                                            </div>
                                            {tarifa_ultimo_dia &&  tarifa_ultimo_dia?.tipo_habitacion?.personas_extra_max && extraUsers > tarifa_ultimo_dia?.tipo_habitacion?.personas_extra_max ? <p className="venta-h-screen__error_persona-extra">{"Límite de personas extra superado, necesitarás PIN para vender"}</p> : null}
                                            </div>
                                        )}
                                    />
                                    {tipoHospedaje === "motel" && (
                                        <Controller
                                            control={methods.control}
                                            name={"extraHospedajes"}
                                            rules={{ required: false, min: 0 }}
                                            render={({ field: { value, onChange } }) => (
                                                <div className="venta-h-screen__count" style={{ columnGap: 10 }}>
                                                    <p className="venta-h-screen__count__label">
                                                        Hospedaje extra
                                                        {false ? (
                                                            <span>{`(${getCurrencyFormat(
                                                                tarifa_ultimo_dia?.costo_hospedaje_extra
                                                            )} c/u)`}</span>
                                                        ) : null}
                                                    </p>
                                                    <Counter
                                                        stepCount={1}
                                                        title="Horas extra"
                                                        className="venta-h-screen__counter"
                                                        max={tarifa_ultimo_dia?.tipo_habitacion?.hospedajes_extra_max || undefined}
                                                        disable={!config.noches_extras || !tarifa_ultimo_dia}
                                                        min={0}
                                                        value={value}
                                                        onClick={onChange}
                                                    />
                                                </div>
                                            )}
                                        />
                                    )}
                                    {tarifa_ultimo_dia?.costo_hora_extra !== undefined &&
                                        tarifa_ultimo_dia?.costo_hora_extra > 0 && (
                                            <Controller
                                                control={methods.control}
                                                name={"extraHours"}
                                                rules={{ required: false, min: 0 }}
                                                render={({ field: { value, onChange } }) => (
                                                    <div
                                                        className="venta-h-screen__count"
                                                        style={{ columnGap: 10, marginTop: 0 }}
                                                    >
                                                        <p className="venta-h-screen__count__label">
                                                            Horas extra
                                                            {false ? (
                                                                <span>{`(${getCurrencyFormat(
                                                                    tarifa_ultimo_dia?.costo_hora_extra
                                                                )} c/u)`}</span>
                                                            ) : null}
                                                        </p>
                                                        <Counter
                                                            stepCount={1}
                                                            title="Horas extra"
                                                            className="venta-h-screen__counter"
                                                            max={tarifa_ultimo_dia?.tipo_habitacion?.horas_extra_max || undefined}
                                                            min={0}
                                                            value={value}
                                                            onClick={onChange}
                                                            disable={!config.horas_extra || tarifa_ultimo_dia?.tipo_habitacion?.horas_extra_max === 0  || !!reserva}
                                                        />
                                                    </div>
                                                )}
                                            />
                                        )}
                                    {tipoHospedaje === TiposAlojamientos.Hotel && (
                                        <Controller
                                            control={methods.control}
                                            name={"earlyCheckIn"}
                                            render={({ field: { value, onChange } }) => (
                                                <div
                                                    className="venta-h-screen__early"
                                                >
                                                    <Switch
                                                        value={value}
                                                        disabled={
                                                            !!(
                                                                // si no hay costo_early_checkin deshabilitar
                                                                (
                                                                    !config.checkin_anticipado ||
                                                                    !costo_early_checkin ||
                                                                    // se corrige deshabilitar el switch de checkin anticipado después de la hora del checkin
                                                                    !isBetween12AMAndCheckInHour ||
                                                                    // Si no hay fecha 1 deshabilitar
                                                                    !dateRange[0] ||
                                                                    // Si no hay fecha 2 deshabilitar
                                                                    !dateRange[1]
                                                                )
                                                                //|| areSameDay(dateRange[0], dateRange[1])
                                                            )
                                                        }
                                                        label={
                                                            <div>
                                                                <span>Check-in anticipado </span>
                                                                {costo_early_checkin > 0 ? (
                                                                    <span className="venta-h-screen__check-anticipado__label">
                                                                        +
                                                                        {formatCurrency(
                                                                            costo_early_checkin
                                                                        )}
                                                                    </span>
                                                                ) : (
                                                                    <></>
                                                                )}
                                                            </div>
                                                        }
                                                        onChange={onChange}
                                                    />
                                                </div>
                                            )}
                                        />
                                    )}
                                </FormSectionRow>
                            </FormSection>
                            <FormSection title="Huésped">
                                <FormSectionRow>
                                    <Controller
                                        control={methods.control}
                                        name={"name"}
                                        render={({ field: { value, onChange } }) => (
                                            <InputText
                                                icon={Icon}
                                                iconProps={{
                                                    name: "userFilled",
                                                    ...inputIconStyle,
                                                }}
                                                inputWrapperClass="venta-habitacion-input"
                                                label={"Nombre completo (Opcional)"}
                                                type={"text"}
                                                placeholder={"Escribe el nombre"}
                                                value={value}
                                                onChange={(e) => onChange(e.target.value)}
                                                onKeyUp={(e) => {
                                                    if (e.key === "Enter") e.preventDefault()
                                                }}
                                                loader={loading}
                                                onBlur={() => {
                                                    getIncidenciasHuesped({
                                                        variables: {
                                                            hotel_id,
                                                            matricula: null,
                                                            huesped: nombreHuesped || null,
                                                        },
                                                    })
                                                }}
                                                error={!!nombreHuesped && !!incidenciasHuesped?.incidencias[0]}
                                                errorhinttext={
                                                    "Huésped con reporte de incidencia. Más detalle en el módulo de incidencias."
                                                }
                                            />
                                        )}
                                    />
                                    <Controller
                                        control={methods.control}
                                        name={"entryType"}
                                        rules={{ required: true }}
                                        render={({ field: { value, onChange } }) => (
                                            <InputTabs
                                                className="venta-habitacion-input"
                                                label={"Tipo de entrada"}
                                                items={entryTypes}
                                                value={value}
                                                onChange={onChange}
                                            />
                                        )}
                                    />
                                    <ModalMatricula
                                        isOpenFromState={isModalMatriculaOpenFromState}
                                        isOpen={isModalMatriculaOpen}
                                        onClose={() => {
                                            setIsModalMatriculaOpen(false)
                                            getIncidenciasMatricula({
                                                variables: {
                                                    hotel_id,
                                                    matricula: matricula || null,
                                                    huesped: null,
                                                },
                                            })
                                        }}
                                        onCancel={() => {
                                            methods.setValue("entryType", entryTypes[0].value as TiposEntradas)
                                            setIsModalMatriculaOpen(false)
                                        }}
                                    />
                                    {!!matricula && (
                                        <div>
                                            <div className="venta-h-screen__edit-matricula__wrapper">
                                                <span
                                                    onClick={() => {
                                                        setIsModalMatriculaOpen(true)
                                                        setIsModalMatriculaOpenFromState("toEdit")
                                                    }}
                                                    className="venta-h-screen__edit-matricula"
                                                >
                                                    {modeloAuto} {matricula}
                                                </span>
                                                <Icon name="pencil" color="var(--primary)" width={20} height={20} />
                                            </div>
                                            {incidenciasMatricula?.incidencias?.[0]
                                                ? <div>
                                                    <p className="venta-h-screen__edit-matricula--error">{"Esta matrícula cuenta con reporte de incidencia."}</p>
                                                    <p className="venta-h-screen__edit-matricula--error">
                                                        {"Consulta"}
                                                        <span onClick={()=>navigate(`/u/incidencias-matricula/${matricula}`, {state: { modelo: modeloAuto }})}>{"aquí"}</span>
                                                        {"para saber más."}
                                                    </p>
                                                </div>
                                            : null}
                                        </div>
                                    )}
                                </FormSectionRow>
                            </FormSection>
                            {isShowingPago && (
                                <FormSection title="Pago" style={{ marginBottom: 0 }}>
                                    <FormSectionRow>
                                        {rolName === RoleNames.valet && (
                                            <div
                                                className="venta-habitacion__inputs"
                                                style={{ margin: 0, marginTop: "16px" }}
                                            >
                                                <PaymentTypeField
                                                    setLovePointsAmount={setLovePointsAmount}
                                                    lovePointsAmount={lovePointsAmount}
                                                />
                                                <PaymentMethodField
                                                    setLovePointsAmount={setLovePointsAmount}
                                                    lovePointsAmount={lovePointsAmount}
                                                />
                                                <CardNumber />
                                            </div>
                                        )}
                                        {rolName !== RoleNames.valet && (
                                            <>
                                                <Controller
                                                    control={methods.control}
                                                    name={"method"}
                                                    rules={{ required: true }}
                                                    render={({ field: { value, onChange }, formState: { errors } }) => (
                                                        <div className="payment-method-field__wrapper">
                                                            <div className="venta-habitacion-input">
                                                                <Dropdown
                                                                    placement={"top"}
                                                                    icon={"creditCard"}
                                                                    iconInOptions={false}
                                                                    errorHintText={
                                                                        errors?.method ? "Selecciona una opción" : ""
                                                                    }
                                                                    label={"Método de pago"}
                                                                    placeholder={"Selecciona una opción"}
                                                                    options={[...usePaymentOptions()]}
                                                                    value={value}
                                                                    onClick={({ value }) => {
                                                                        onChange(value)
                                                                        if (value === PAYMENT_TYPES.mixto) {
                                                                            dispatch(toggleModalPagoMixtoOpen(true))
                                                                        } else {
                                                                            const costs = methods.getValues("costs")
                                                                            methods.setValue("extra", [
                                                                                {
                                                                                    amount: costs?.general,
                                                                                    type: value,
                                                                                    number: "",
                                                                                    easyrewards_id:
                                                                                        lovePointsAmount?.id,
                                                                                },
                                                                            ])
                                                                        }
                                                                    }}
                                                                />
                                                            </div>

                                                            {!isModalPagoMixtoOpen && value === "mixto" ? (
                                                                <span
                                                                    className="payment-method-field__link"
                                                                    style={{ marginTop: 32 }}
                                                                    onClick={() => {
                                                                        dispatch(toggleModalPagoMixtoOpen(true))
                                                                        dispatch(toggleModalPagoMixtoEdited(true))
                                                                    }}
                                                                >
                                                                    {"Editar"}
                                                                </span>
                                                            ) : null}
                                                        </div>
                                                    )}
                                                />

                                                <ModalMixto
                                                    paymentOptions={[
                                                        PAYMENT_METHODS.efectivo,
                                                        PAYMENT_METHODS.visaOMasterCard,
                                                        PAYMENT_METHODS.amex,
                                                        PAYMENT_METHODS.depositoOTransferencia,
                                                        PAYMENT_METHODS.cortesia,
                                                        PAYMENT_METHODS.consumoInterno,
                                                    ]}
                                                    visible={isModalPagoMixtoOpen}
                                                    edited={isModalPagoMixtoEdited}
                                                    onLovePointsChange={handleLovePointsChange}
                                                    onClose={() => {
                                                        dispatch(toggleModalPagoMixtoOpen(false))
                                                        dispatch(toggleModalPagoMixtoEdited(false))
                                                    }}
                                                />
                                                <div className="payment-method-fields">
                                                    {(methods.getValues("method") ===
                                                        PAYMENT_METHODS.visaOMasterCard.value ||
                                                        methods.getValues("method") === PAYMENT_METHODS.amex.value ||
                                                        methods.getValues("method") ===
                                                            PAYMENT_METHODS.depositoOTransferencia.value) && (
                                                        <>
                                                            <div>
                                                                <CardNumberField
                                                                    setLovePointsAmount={setLovePointsAmount}
                                                                />
                                                            </div>
                                                            <div className="easyrewards-abonar__input-text">
                                                                <AbonarEasyRewardsField
                                                                    setLovePointsAmount={setLovePointsAmount}
                                                                    lovePointsAmount={lovePointsAmount}
                                                                />
                                                            </div>
                                                        </>
                                                    )}

                                                    {methods.getValues("method") === PAYMENT_METHODS.mixto.value && (
                                                        <div className="easyrewards-abonar__input-text">
                                                            <AbonarEasyRewardsField
                                                                setLovePointsAmount={
                                                                    methods.getValues("method") ===
                                                                    PAYMENT_TYPES.LovePoints
                                                                        ? handleLovePointsChange
                                                                        : setLovePointsAmount
                                                                }
                                                                lovePointsAmount={lovePointsAmount}
                                                            />
                                                        </div>
                                                    )}

                                                    {methods.getValues("method") === PAYMENT_METHODS.efectivo.value && (
                                                        <div className="easyrewards-abonar__input-text">
                                                            <AbonarEasyRewardsField
                                                                setLovePointsAmount={setLovePointsAmount}
                                                                lovePointsAmount={lovePointsAmount}
                                                            />
                                                        </div>
                                                    )}
                                                    {methods.getValues("method") ===
                                                        PAYMENT_METHODS.consumoInterno.value && (
                                                        <div className="easyrewards-abonar__input-text">
                                                            <Controller
                                                                control={methods.control}
                                                                name="colaboradorConsumoInterno"
                                                                rules={{
                                                                    required: true,
                                                                    validate: (v) => !!v?.id && !!v?.title,
                                                                }}
                                                                render={({
                                                                    field: { value, onChange },
                                                                    fieldState: { error },
                                                                }) => (
                                                                    <InputTextSuggestions
                                                                        suggestionsListWidth="255px"
                                                                        suggestions={
                                                                            colaboradores?.colaboradores?.map((c) => ({
                                                                                title: `${c.nombre} ${c.apellido_paterno} ${c.apellido_materno}`,
                                                                                id: c.colaborador_id,
                                                                            })) || []
                                                                        }
                                                                        value={value || ""}
                                                                        inputTextConfig={{
                                                                            label: "Nombre del personal",
                                                                            placeholder: "Nombre del personal",
                                                                            type: "text",
                                                                            icon: accountBoxFill,
                                                                            error: !!error,
                                                                            errorhinttext:
                                                                                error?.type === "validate" ||
                                                                                error?.type === "required"
                                                                                    ? "Escribe el nombre del responsable"
                                                                                    : "",
                                                                        }}
                                                                        onChange={onChange}
                                                                    />
                                                                )}
                                                            />
                                                        </div>
                                                    )}
                                                    {methods.getValues("method") ===
                                                        PAYMENT_METHODS.lovePoints.value && (
                                                        <>
                                                            <CardNumberField
                                                                setLovePointsAmount={setLovePointsAmount}
                                                            />
                                                            {withEasyrewards && (
                                                                <div className="venta-habitacion__consultar-saldo">
                                                                    <span
                                                                        className="venta-habitacion__consultar-saldo__link"
                                                                        onClick={() => {
                                                                            const numero = methods
                                                                                .getValues("extra.0.number")
                                                                                ?.trim()
                                                                            if (!numero) return

                                                                            if (!lovePointsAmount?.id) {
                                                                                return
                                                                            } else if (lovePointsAmount?.saldo === 0) {
                                                                                setModalMessage(
                                                                                    "Tu saldo actual de Love Points es insuficiente. Actualmente tienes <strong>0 puntos</strong> disponibles. Intenta con otro método de pago."
                                                                                )
                                                                                setModalLovePointsErrorOpen(true)
                                                                                return
                                                                            } else {
                                                                                setModalPagoMixtoLovePointsOpen(true)
                                                                            }
                                                                        }}
                                                                        style={{
                                                                            cursor: methods
                                                                                .getValues("extra.0.number")
                                                                                ?.trim()
                                                                                ? "pointer"
                                                                                : "not-allowed",
                                                                            opacity: methods
                                                                                .getValues("extra.0.number")
                                                                                ?.trim()
                                                                                ? 1
                                                                                : 0.5,
                                                                        }}
                                                                    >
                                                                        Consultar saldo
                                                                    </span>
                                                                </div>
                                                            )}
                                                        </>
                                                    )}
                                                </div>
                                            </>
                                        )}
                                    </FormSectionRow>
                                </FormSection>
                            )}
                            {isShowingPagoReserva && !isShowingPago && reserva && (
                                <FormSection title="Pago" style={{ marginBottom: 0 }}>
                                    <FormSectionRow>
                                        <div className="easyrewards-abonar__input-text">
                                            <AbonarEasyRewardsField
                                                setLovePointsAmount={setLovePointsAmount}
                                                lovePointsAmount={lovePointsAmount}
                                            />
                                        </div>
                                    </FormSectionRow>
                                </FormSection>
                            )}
                            {rolName !== RoleNames.valet && (
                                <>
                                    {isValidPropina(method) && !reserva && (
                                        <FormSection title="Propina (opcional)" toggable>
                                            <FormSectionRow style={{ alignItems: "center" }}>
                                                <Controller
                                                    name="porcentajePropina"
                                                    control={methods.control}
                                                    render={({ field: { onChange, value } }) => (
                                                        <InputTabs
                                                            className={"registro-incidencia__tabs-place"}
                                                            label={"Monto o porcentaje"}
                                                            items={[
                                                                {
                                                                    bigLabel: "10%",
                                                                    label: `$${times(costos.general, 0.1)}`,
                                                                    value: "0.1",
                                                                },
                                                                {
                                                                    bigLabel: "15%",
                                                                    label: `$${times(costos.general, 0.15)}`,
                                                                    value: "0.15",
                                                                },
                                                                {
                                                                    label: "Otro monto",
                                                                    icon: "dollarCircle",
                                                                    value: "Otro",
                                                                },
                                                            ]}
                                                            withCheckOnSelected
                                                            value={value + ""}
                                                            onChange={onChange}
                                                        />
                                                    )}
                                                />
                                                {porcentajePropina === "Otro" && (
                                                    <Controller
                                                        control={methods.control}
                                                        name="montoPropina"
                                                        rules={{ required: true, validate: (v) => (v || 0) > 0 }}
                                                        render={({
                                                            field: { onChange, value },
                                                            fieldState: { error },
                                                        }) => (
                                                            <InputMoney
                                                                value={value}
                                                                onChange={onChange}
                                                                inputWrapperClass="venta-habitacion-input"
                                                                placeholder="Monto de propina"
                                                                label="Monto de propina"
                                                                icon={DollarCircle}
                                                                error={!!error}
                                                                errorhinttext={
                                                                    error?.type === "validate"
                                                                        ? "Ingresa una propina mayor a 0"
                                                                        : ""
                                                                }
                                                            />
                                                        )}
                                                    />
                                                )}
                                            </FormSectionRow>
                                            <FormSectionRow>
                                                <Controller
                                                    control={methods.control}
                                                    name="colaboradorRecibioPropina"
                                                    rules={{
                                                        required: !!propinasFormatted.length,
                                                        validate: (v) =>
                                                            !propinasFormatted.length || (!!v?.id && !!v?.title),
                                                    }}
                                                    render={({ field: { value, onChange }, fieldState: { error } }) => (
                                                        <InputTextSuggestions
                                                            suggestionsListWidth="255px"
                                                            className="venta-habitacion-input"
                                                            suggestions={
                                                                colaboradores?.colaboradores?.map((c) => ({
                                                                    title: `${c.nombre} ${c.apellido_paterno} ${c.apellido_materno}`,
                                                                    id: c.colaborador_id,
                                                                })) || []
                                                            }
                                                            value={value || ""}
                                                            inputTextConfig={{
                                                                label: "¿Quién recibió la propina?",
                                                                placeholder: "Nombre del personal",
                                                                type: "text",
                                                                icon: accountBoxFill,
                                                                error: !!error,
                                                                errorhinttext:
                                                                    error?.type === "validate" ||
                                                                    error?.type === "required"
                                                                        ? "Escribe el nombre del responsable"
                                                                        : "",
                                                            }}
                                                            onChange={onChange}
                                                        />
                                                    )}
                                                />
                                            </FormSectionRow>
                                        </FormSection>
                                    )}
                                </>
                            )}
                            {method === PAYMENT_TYPES.mixto &&
                                !!propinasFormatted?.length &&
                                !reserva && (
                                    <FormSection title="Propina">
                                        <FormSectionRow>
                                            <Controller
                                                control={methods.control}
                                                name="colaboradorRecibioPropina"
                                                rules={{
                                                    required: true,
                                                    validate: (v) => !!v?.id && !!v?.title,
                                                }}
                                                render={({ field: { value, onChange }, fieldState: { error } }) => (
                                                    <InputTextSuggestions
                                                        suggestionsListWidth="255px"
                                                        suggestions={
                                                            colaboradores?.colaboradores?.map((c) => ({
                                                                title: `${c.nombre} ${c.apellido_paterno} ${c.apellido_materno}`,
                                                                id: c.colaborador_id,
                                                            })) || []
                                                        }
                                                        value={value || ""}
                                                        inputTextConfig={{
                                                            inputWrapperClass: "venta-habitacion-input",
                                                            label: "¿Quién recibió la propina?",
                                                            placeholder: "Nombre del personal",
                                                            type: "text",
                                                            icon: accountBoxFill,
                                                            error: !!error,
                                                            errorhinttext:
                                                                error?.type === "validate"
                                                                    ? "Escribe el nombre del responsable"
                                                                    : "",
                                                        }}
                                                        onChange={onChange}
                                                    />
                                                )}
                                            />
                                        </FormSectionRow>
                                    </FormSection>
                                )}
                        </div>
                        <Resumen 
                            descuento={{ nombre: descuento.nombre, total: descuento.total }}
                            onOpenDescuento={() => setDescuento({  ...descuento, visible: true })}
                            disabled={isVentaLoading || isDataLoading}
                            totalPropinas={sum(propinasFormatted.map((p) => p.subtotal))}
                            roomDays={roomDays}
                            lovePointsAmount={lovePointsAmount}
                            hotelId={hotel_id}
                            tarifas={resumen_tarifas.hospedaje}
                            tarifasPersonaExtra={resumen_tarifas.personas_extra}
                            pagos={[
                                ...(reserva ? (reserva?.pagos || []).flatMap((p) =>
                                    (p?.detalles_pago || []).flatMap((dp) => ({
                                        amount: dp?.subtotal || 0,
                                        type: dp?.tipo_pago || "",
                                        number: dp?.ultimos_digitos || dp?.numero_referencia || "",
                                        easyrewards_id: lovePointsAmount?.id,
                                    }))
                                ) : []),
                                ...(pagos.length > 0 ? pagos.map((pago, index) => {
                                    return {
                                        montoPropina: propinas
                                            ? propinas?.find((p) => Number(p?.id) === index)?.value
                                            : Number(montoPropina) || 0,
                                        amount:
                                            pago.type === PAYMENT_TYPES.LovePoints
                                                ? pago.amount || costos.total
                                                : pago.amount || 0,
                                        type: pago.type,
                                        number: pago.number,
                                        easyrewards_id: lovePointsAmount?.id,
                                    }
                                }) : [])
                            ]}
                            totalAdelantosReserva={sum(
                                reserva?.pagos?.map((p) => p.total) || []
                            )}
                            costs={costos}
                            placas={matricula}
                            modelo={modeloAuto}
                            marca={marcaAuto}
                            color={colorAuto}
                            startDate={dateRange?.[0] ? formatCustomDate(dateRange[0], "YYYY-MM-DD") : undefined}
                            endDate={dateRange?.[1] ? formatCustomDate(dateRange[1], "YYYY-MM-DD") : undefined}
                            nombreHuesped={nombreHuesped}
                            personas={personas}
                            personasExtras={extraUsers}
                            personasExtrasMax={tarifa_ultimo_dia?.tipo_habitacion?.personas_extra_max || 0}
                            tipoEntrada={tipoEntrada}
                            tipoTarifa={tipoHospedaje as TiposAlojamientos}
                            horasExtras={extraHours}
                            isMixto={method === "mixto"}
                            onSubmit={() => methods.handleSubmit(onSubmit)()}
                            experiencias={experiencias}
                            extraHospedajes={extraHospedajes}
                        />
                    </div>
                </form>
                <LoaderComponent visible={isVentaLoading} />
                {isModalLovePointsErrorOpen && (
                    <ModalLovePointsError
                        isOpen={isModalLovePointsErrorOpen}
                        setIsOpen={setModalLovePointsErrorOpen}
                        description={modalMessage}
                        onCloseDialog={() => setModalLovePointsErrorOpen(false)}
                    />
                )}
                <ModalPagoMixtoLovePoints
                    visible={isModalPagoMixtoLovePointsOpen}
                    onClose={() => setModalPagoMixtoLovePointsOpen(false)}
                    lovePointsAmount={lovePointsAmount}
                    paymentOptions={[
                        PAYMENT_METHODS.efectivo,
                        PAYMENT_METHODS.visaOMasterCard,
                        PAYMENT_METHODS.amex,
                        PAYMENT_METHODS.cortesia,
                        PAYMENT_METHODS.consumoInterno,
                        PAYMENT_METHODS.depositoOTransferencia,
                    ]}
                />
            </FormProvider>
            {descuento.visible && (
                <ModalDescuentos
                    filter={{
                        type: "renta",
                        tipo_habitacion_ids: tipo_habitacion_id ? [tipo_habitacion_id] : undefined,
                        grupo_descuento: tipoHospedaje,
                        fecha_inicio: dateRange?.[0] ? dateRange[0]?.toISOString()  : "",
                        fecha_fin: dateRange?.[1] ? dateRange?.[1]?.toISOString()  : "",
                        total: methods.getValues("costs.total")
                    }}
                    onChange={(v) => {
                        setDescuento({ descuento_id: v.descuento_id, total: v.total, nombre:  v.nombre, visible: false })
                        const values = methods.getValues("extra")?.[0]
                        const costo = Number(methods.getValues("costs.total") || 0)
                        if (!v.descuento_id) {
                            methods.setValue("extra", [{...values, amount: costo }])
                        } else if (method === PAYMENT_METHODS.mixto.value) {
                            resetAfterDescuento()
                        } else if (!metodos_sin_descuento.includes(method as TiposPagos)) {
                            methods.setValue("extra", [{...values, amount: minus(costo, v.total) }])
                        }
                    }}
                    onClose={()=> setDescuento({...descuento, visible: false})}
                    value={{ descuento_id: descuento.descuento_id, total: descuento.total, nombre: descuento.nombre }}
                />
            )}
            {Modal}
            {ModalAuthCortesiaFromMixto}
            {ModalAuthCortesia}
        </Screen>
    )
}

export default VentaHabitacion
